<template>
  <TopGradientBlockLayout ref="transactions_list" style="height: auto;">
    <div class="flex items-center mb-12">
      <div class="text-xl font-bold text-text leading-tight">{{ $t('transactionsTitle') }}</div>
      <div v-if="main_chart_selected_point"
           class="text-md text-text-ternary font-bold ml-auto flex items-center">
        {{ $t('fromDate') }} {{ humanized_date(selected_point_date_range(filters.group_by).start) }}
        {{ $t('toDate') }} {{ humanized_date(selected_point_date_range(filters.group_by).end) }}
        <div class="bg-red rounded cursor-pointer hover:bg-red-hover
                   transition duration-200 text-white text-md  px-2  ml-2" @click="setChartPoint(null)">
          <font-awesome-icon icon="times"/>
        </div>
      </div>
      <div v-else
           class="text-md text-text-ternary font-bold ml-auto">
        {{ $t('fromDate') }} {{ humanized_date(filters.date.start) }}
        {{ $t('toDate') }} {{ humanized_date(filters.date.end) }}
      </div>
    </div>
    <template v-if="!!Object.keys(transactionsByDate).length">
      <div class="mb-12">
        <div v-for="(transactionDate,date,i) in transactionsByDate" :key="i">
          <TransactionDate :date="date" :transactions="transactionDate" class="md:-mx-6"/>
          <TransactionItem v-for="(transaction,j) in transactionDate" :key="j"
                           :transaction="transaction"
                           @edit="edit_transaction = $event"
                           :layout="'default'"/>
        </div>
      </div>
      <div v-show="!!transactions.data.length"
           class="flex items-center bg-bg-to-block-gradient rounded-b
                -mx-12 -mb-12 lg:-m-12 lg:mt-0
                px-8 pt-10 pb-10 lg:p-12 lg:pt-15 lg:pb-15">
        <Pagination :pagination="pagination"
                    @page="setPage"/>
        <TransactionsTotal class="ml-auto"
                           v-if="!!transactions.total_data && !!transactions.total_data.total"
                           :totals="transactions.total_data"
                           :tooltip="false"/>
      </div>
    </template>
    <template v-else>
      <div class="text-center text-xl text-text font-medium">{{ $t('notFound') }}</div>
    </template>
    <TransactionEditModalProvider :transaction="edit_transaction"
                                  :position="'absolute'"
                                  @finished="fetchReportData"
                                  @close="edit_transaction = null"/>
  </TopGradientBlockLayout>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import Pagination from "@/components/UI/Pagination/Pagination";
import TransactionsTotal from "@/components/cabinet/Money/Transactions/TransactionsTotal";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import TransactionEditModalProvider
  from "@/components/common/Transaction/TransactionEditModal/TransactionEditModalProvider";
import TransactionDate from "@/components/common/Transaction/TransactionDate";
import TransactionItem from "@/components/common/Transaction/TransactionItem/TransactionItem";

export default {
  name: "ReportIncomeTransactions",
  components: {
    TransactionItem,
    TransactionDate,
    TransactionEditModalProvider,
    TopGradientBlockLayout, TransactionsTotal, Pagination
  },
  data() {
    return {
      edit_transaction: null
    }
  },
  computed: {
    ...mapState('reports/report_income', ['transactions', 'pagination', 'main_chart_selected_point']),
    ...mapState('reports/report_filters', ['filters']),
    ...mapGetters('reports/report_income', ['transactionsByDate', 'selected_point_date_range']),
  },
  methods: {
    ...mapActions('reports/report_income', ['getChartPointData', 'fetchTransactions', 'fetchReportData']),
    ...mapMutations('reports/report_income', ['setChartPoint', 'setPage', 'resetPagination']),

    humanized_date(val) {
      return this.$moment(val).format('DD.MM.YYYY')
    },
  },
  watch: {
    'pagination.current_page': {
      handler() {
        this.fetchTransactions();
      }
    },
    main_chart_selected_point: {
      handler() {
        this.getChartPointData();
        this.resetPagination();
        this.fetchTransactions();
      }
    }
  },
  i18n: {
    messages: {
      en: {
        transactionsTitle: 'Incomes list',
        notFound: 'No transactions in this period',
        fromDate: 'from',
        toDate: 'to'
      },
      ru: {
        transactionsTitle: 'Список доходов',
        notFound: 'За данный период транзакций не найдено',
        fromDate: 'с',
        toDate: 'по'
      }
    }
  }
}
</script>